"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CORSRule_1 = require("./_CORSRule");
exports._CORSRules = {
    type: "list",
    flattened: true,
    member: {
        shape: _CORSRule_1._CORSRule
    }
};
//# sourceMappingURL=_CORSRules.js.map